import Alpine from "alpinejs";
import AsyncAlpine from "async-alpine";
import collapse from "@alpinejs/collapse";
import focus from '@alpinejs/focus';
import mask from '@alpinejs/mask';

/* 1st party magic */
import "./_magic/smoothscroll.js";

/* 1st party components */
import { app } from "./app.js";
import { countdown, countdownLabel } from "./countdown.js";
import { panzoom } from "./panzoom.js";
import { serverTime } from "./server-time.js";
import { basicSlideshow, testimonialsSlideshow } from "./splide.js";

/* plugins */
Alpine.plugin(AsyncAlpine);
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(mask);

/* stores */
Alpine.store("serverTime", serverTime);

/* data components */
Alpine.data("app", app);
Alpine.data("countdown", countdown);
Alpine.data("countdownLabel", countdownLabel);
Alpine.data("panzoom", panzoom);
Alpine.data("basicSlideshow", basicSlideshow);
Alpine.data("testimonialsSlideshow", testimonialsSlideshow);

/* lazy-loaded components — mapbox-gl is split into its own chunk,
   fetched only when a map element appears (incl. Unpoly fragments) */
Alpine.asyncData("markeredMapbox", () => import("./mapbox.js"));
Alpine.asyncData("plottedMapbox", () => import("./mapbox.js"));

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
